// import React, { useState, useEffect } from 'react';
// import './Navbar.css';

// export default function Navbar({ onFormOpen }) {
//   const [scrolled, setScrolled] = useState(false);
//   const [menuOpen, setMenuOpen] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => setScrolled(window.scrollY > 50);
//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   const navLinks = [
//     { label: 'Home', href: '#hero' },
//     { label: 'Gallery', href: '#gallery' },
//     { label: 'Equipment', href: '#equipment' },
//     { label: 'Reviews', href: '#reviews' },
//     { label: 'Location', href: '#location' },
//   ];

//   return (
//     <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
//       <div className="navbar__inner">
//         <a href="#hero" className="navbar__logo">
//           <span className="navbar__logo-gym">GYM</span>
//           <span className="navbar__logo-arena">ARENA</span>
//         </a>

//         <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
//           {navLinks.map(link => (
//             <li key={link.label}>
//               <a href={link.href} onClick={() => setMenuOpen(false)}>{link.label}</a>
//             </li>
//           ))}
//         </ul>

//         <button className="navbar__cta" onClick={onFormOpen}>
//           Fill Form
//         </button>

//         <button
//           className={`navbar__hamburger ${menuOpen ? 'open' : ''}`}
//           onClick={() => setMenuOpen(!menuOpen)}
//           aria-label="Toggle menu"
//         >
//           <span /><span /><span />
//         </button>
//       </div>
//     </nav>
//   );
// }

import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { useGym } from '../context/GymContext';
import { motion } from 'framer-motion';
import logo from '../assests/logo.png';

export default function Navbar({ onFormOpen }) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { data } = useGym();
  const { gym } = data;

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Home', href: '#hero' },
    { label: 'About', href: '#about' },
    { label: 'Gallery', href: '#gallery' },
    { label: 'Equipment', href: '#equipment' },
    { label: 'Reviews', href: '#reviews' },
    { label: 'Location', href: '#location' },
  ];

  // 🔥 Navbar container animation
  const navAnim = {
    hidden: { y: -80, opacity: 0 },
    show: { y: 0, opacity: 1 },
  };

  // 🔥 Stagger container for links
  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.3,
      },
    },
  };

  // 🔥 Individual link animation
  const item = {
    hidden: { opacity: 0, y: -10 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <motion.nav
      className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}
      variants={navAnim}
      initial="hidden"
      animate="show"
      transition={{ duration: 0.6 }}
    >
      <div className="navbar__inner">

      <a href="#hero" className="navbar__logo">
  <img src={logo} alt="Gym Arena Logo" className="navbar__logo-img" />
  
  <div className="navbar__logo-text">
    <span className="navbar__logo-gym">GYM</span>
    <span className="navbar__logo-arena">ARENAA</span>
  </div>
</a>

        {/* Links */}
        <motion.ul
          className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}
          variants={container}
          initial="hidden"
          animate="show"
        >
          {navLinks.map((link) => (
            <motion.li key={link.label} variants={item}>
              <a href={link.href} onClick={() => setMenuOpen(false)}>
                {link.label}
              </a>
            </motion.li>
          ))}
        </motion.ul>

        {/* CTA Button */}
        <motion.button
          className="navbar__cta"
          onClick={onFormOpen}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.8, duration: 0.4 }}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Fill Form
        </motion.button>

        {/* Hamburger */}
        <button
          className={`navbar__hamburger ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>

      </div>
    </motion.nav>
  );
}